import { takeEvery, call, put, delay, take } from 'redux-saga/effects'
import store from '../store'
import { formatFiToISO } from '../utils/DateTimeFormat'
import {
  SEARCH_ADMIN_INVOICE,
  API_SERVER,
  EXPAND_ADMIN_INVOICE,
  SEARCH_ADMIN_USERS,
  //CHANGE_ADMIN_MENU,
  UPDATE_ADMIN_INVOICE,
  EXPAND_ADMIN_USER,
  UPDATE_ADMIN_USER,
  SEARCH_ADMIN_WAGES,
  UPDATE_ADMIN_INVOICE_STATUS,
  UPDATE_ADMIN_SALARY_STATUS,
  ADMIN_ADD_NEW_UPDATES,
  ADMIN_DELETE_COMPANY_UPDATE,
  ADMIN_GET_UPDATES,
  NO_PIKAPALKKA,
  SHOW_SALARY_PDF,
  SHOW_INVOICE_PDF,
  UPDATE_ADMIN_INVOICE_STATUS_REJECTED,
  UPDATE_ADMIN_INVOICE_STATUS_NEW,
  UPDATE_ADMIN_INVOICE_STATUS_LOANED,
  UPDATE_ADMIN_INVOICE_STATUS_NOT_ACCEPTED,
  UPDATE_ADMIN_INVOICE_STATUS_PAID_AND_NEW_INVOICE,
  UPDATE_ADMIN_INVOICE_STATUS_PERINNASSA,
  SENT_INVOICE_REMINDER,
  IMPORT_KASSAVIRTANEN_SALARIES,
  SALARY_SEND_TO_IR,
  CANCEL_SALARY_IR_REPORT,
  MANUAL_PAY_SALARIES,
  SHOW_REMINDER_INVOICE_PDF,
  GET_ADMIN_EXPENSE_REPORT,
  RESONIA_API_SERVER,
  SEARCH_ADMIN_IR,
  UPDATE_ADMIN_SALARY_STATUS_IR,
  CANCEL_UPDATE_ADMIN_SALARY_STATUS,
  PAYMENTS_API_SERVER,
  PAYMENTS_API_PATH_USERS,
  PAYMENTS_API_PATH_MAIN_ACCOUNT,
  PAYMENTS_API_PATH_SERVICE_ACCOUNT,
  PAYMENTS_API_PATH_ULOSOTTO,
  SEARCH_COMPANY_INVOICES,
  DUE_DATE_FEE,
  PARTIAL_PAY_FEE,
  INTEREST_FEE,
  SHOW_LATEST_INVOICE_PDF,
  EXPAND_ADMIN_SALARY,
  UPDATE_ADMIN_SALARY,
  DOWNLOAD_CUSTOMERS_REPORT,
  GET_ADMIN_SALARY_ULOSOTTO_INFO,
  SEARCH_COMPANY_SALARIES,
  SEARCH_COMPANY_CUSTOMERS
} from '../constants'
// import { convertStateToInt } from '../utils/invoice.utils'
import {
  apiManualPost,
  apiManualRequest,
  apiBlobPost,
  createUploadFileChannel
} from '../utils/request'
import {
  searchAdminInvoiceSuccess,
  searchAdminInvoiceFailed,
  searchAdminWagesSuccess,
  searchAdminWagesFailed,
  expandAdminInvoiceTrue,
  expandAdminInvoiceFalse,
  searchAdminUsersSuccess,
  // updateAdminInvoiceResult,
  searchAdminUsersFailed,
  expandAdminUserFalse,
  expandAdminUserTrue,
  updateAdminUserResult,
  updateAdminUserResultFailed,
  updateAdminInvoiceStatusSuccess,
  updateAdminSalaryStatusSuccess,
  updateAdminSalaryStatusFailed,
  //adminAddNewUpdatesSuccess,
  adminGetUpdatesSuccess,
  adminGetUpdates,
  updateAdminBankPaymentFailed,
  updateAdminIRFailed,
  getAdminExpenseReportSuccess,
  getAdminExpenseReportFailed,
  searchAdminIRWagesFailed,
  searchAdminIRWagesSuccess,
  closeLoadSalaryItems,
  closeAdminUserForms,
  closeAdminUserFormsSuccess,
  updateAdminTable,
  cancelUpdateAdminSalaryStatusSuccess,
  searchAdminInvoice,
  closeAdminInvoiceForms,
  closeAdminInvoiceFormsSuccess,
  adminSendNewInvoiceSuccess,
  adminGeneratePDFFailed,
  adminGeneratePDFSuccess,
  showInvoicePDF,
  showReminderInvoicePDF,
  searchAdminInvoiceAllRowsSuccess,
  //generatePartialPDFSuccess,
  adminUpdateIndustryTaxCardSuccess,
  adminUpdateIndustryTaxCardFailed,
  generateIndustryTaxPDFSuccess,
  generateIndustryTaxPDFFailed,
  searchAdminAllSalaryRecarodsSuccess,
  ssnDuplicate,
  expandAdminSalaryTrue,
  expandAdminSalaryFalse,
  closeAdminSalaryForms,
  closeAdminSalaryFormsSuccess,
  getUserCompanyUpdateInfo,
  loadSalaryItems,
  getAdminSalaryUlosottoInfoSuccess,
  searchAdminWages,
  searchAdminUsers
} from '../actions/index'
import DateTimeFormat from '../utils/DateTimeFormat'
import { setFieldValue, intersection } from '../form'
import { defaultValues as taxCardDefaultValues } from '../components/profile/tax.component'
import createExcelCustomersReport from '../utils/createExcelCustomersReport'

function* adminInvoiceSearchSaga({ selectedPage, refreshSearch, formValues }) {
  try {
    yield put(closeAdminInvoiceForms())
    refreshSearch = selectedPage == null ? true : refreshSearch || false
    selectedPage = selectedPage == null ? 0 : selectedPage.selected
    // Pagination size  - number of rows to fetch

    const rows = (selectedPage + 1) * formValues.adminInvoicePageSize

    // Always request {rows} number of records from the first page with 0 offset.
    // This avoids real time data issues with offset based pagination. New records are
    // always at the start of the first page and old records get pushed down to newer pages.
    // This method is implemented as performance is very fast for initial set of pages and
    // slowness is encountered only if we move to hundreds of pages.
    // (worst case running time is while navigating to the last page without any filters enabled,
    // i.e. fetch of all the data in the system)

    const url = `${API_SERVER}/SearchInvoices?rows=${rows}`
    let instant_payment, overdue, body, status, country, is_manual_pay

    if (formValues === undefined) {
      body = {}
    } else {
      if (formValues.instant_payment !== undefined) {
        instant_payment = formValues.instant_payment
        if (instant_payment === true) {
          instant_payment = 'quick_pay'
        } else if (instant_payment === false) {
          instant_payment = undefined
        }
      }

      if (formValues.overdue !== undefined) {
        overdue = formValues.overdue
        if (overdue === true) {
          overdue = 'overdue'
        } else if (overdue === false) {
          overdue = undefined
        }
      }

      if (formValues.country !== undefined) {
        country = formValues.country
        if (country === true) {
          country = 'abroad'
        } else if (country === false) {
          country = undefined
        }
      }

      if (formValues.is_manual_pay !== undefined) {
        is_manual_pay = formValues.is_manual_pay
      }

      let startdate
      if (formValues.startdate) {
        startdate = formatFiToISO(
          new DateTimeFormat('fi', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
          })
            .format(new Date(formValues.startdate))
            .split('.')
        )
      }

      let enddate
      if (formValues.enddate) {
        enddate = formatFiToISO(
          new DateTimeFormat('fi', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
          })
            .format(new Date(formValues.enddate))
            .split('.')
        )
      }

      if (
        formValues.yearSelect &&
        (formValues.startdate === undefined || formValues.startdate === null) &&
        formValues.yearSelect &&
        (formValues.enddate === undefined || formValues.enddate === null)
      ) {
        startdate = formatFiToISO(
          new DateTimeFormat('fi', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
          })
            .format(new Date(`January 01, ${formValues.yearSelect}`))
            .split('.')
        )

        enddate = formatFiToISO(
          new DateTimeFormat('fi', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
          })
            .format(new Date(`December 31, ${formValues.yearSelect}`))
            .split('.')
        )
      }

      let paymentdate
      if (formValues.paymentdate) {
        paymentdate = formatFiToISO(
          new DateTimeFormat('fi', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
          })
            .format(new Date(formValues.paymentdate))
            .split('.')
        )
      }

      if (formValues.status !== undefined) {
        status = formValues.status
      }

      body = {
        email: formValues.user_email,
        firstname: formValues.firstname,
        customer: [
          {
            company_name: formValues.company_name,
            customer_name: formValues.customer_name,
            Invoice: [
              {
                invoice_id: formValues.invoice_id,
                referencenumber: formValues.referencenumber,
                startdate: startdate,
                enddate: enddate,
                instant_payment: instant_payment,
                overdue_inv: overdue,
                status: status,
                country: country,
                is_manual_pay: is_manual_pay,
                payment_received_date: paymentdate
              }
            ]
          }
        ]
      }
    }

    const result = yield call(apiManualPost, url, JSON.stringify(body))

    const invoices = []

    result[Symbol.iterator] = function* () {
      const keys = Reflect.ownKeys(this)
      for (const key of keys) {
        yield this[key]
      }
    }

    const data = JSON.parse(result.data)
    for (const invoice of data.Invoices) {
      invoices.push(invoice)
    }

    // total invoices counted
    const total_count = data.Total_Count

    var invoiceSummary = null

    if (refreshSearch) {
      //Calling SearchInvoiceSummary API
      const searchInvoiceSummaryUrl = `${API_SERVER}/SearchInvoiceSummary`
      const invoiceSummaryResponse = yield call(
        apiManualPost,
        searchInvoiceSummaryUrl,
        JSON.stringify(body)
      )

      invoiceSummary = JSON.parse(invoiceSummaryResponse.data)[0]
    }

    yield put(
      searchAdminInvoiceSuccess(
        invoices,
        data.Total_Count,
        selectedPage,
        refreshSearch,
        invoiceSummary,
        formValues.adminInvoicePageSize
      )
    )

    yield put(closeAdminInvoiceFormsSuccess())

    // KAS-337 calling full the invoices when month searched or loppupvm searched
    if (
      invoices.length > 0 &&
      ((formValues.startdate !== undefined &&
        formValues.enddate !== undefined) ||
        formValues.enddate !== undefined) // PI-295 Fetching all invoice records when Loppupvm is searched
    ) {
      const allRowsUrl = `${API_SERVER}/SearchInvoices?rows=${total_count}`
      const resultAllRows = yield call(
        apiManualPost,
        allRowsUrl,
        JSON.stringify(body)
      )

      const allInvoicesSearch = []

      resultAllRows[Symbol.iterator] = function* () {
        const keys = Reflect.ownKeys(this)
        for (const key of keys) {
          yield this[key]
        }
      }

      const resultAllRowsParse = JSON.parse(resultAllRows.data)
      for (const invoice of resultAllRowsParse.Invoices) {
        allInvoicesSearch.push(invoice)
      }

      yield put(searchAdminInvoiceAllRowsSuccess(allInvoicesSearch))
    }
  } catch (e) {
    yield put(searchAdminInvoiceFailed(e))
  }
}

function* adminUsersSearchSaga({ formValues }) {
  try {
    yield put(closeAdminUserForms())
    const url = `${API_SERVER}/SearchCustomers`

    let body = { ...formValues }
    const result = yield call(apiManualPost, url, JSON.stringify(body))

    const parsedResult = JSON.parse(result.data)
    yield put(searchAdminUsersSuccess(parsedResult))
    yield put(closeAdminUserFormsSuccess())
  } catch (e) {
    yield put(searchAdminUsersFailed(e))
  }
}

function* adminWagesSearchSaga({ selectedPage, refreshSearch, formValues }) {
  try {
    yield put(closeAdminSalaryForms())

    // Selected page gets sent only from the pagination component for changing
    // the page.

    refreshSearch = selectedPage == null ? true : refreshSearch || false
    const has_yel = formValues.has_yel ? 'true' : 'false'
    const has_ulosotto = formValues.has_ulosotto ? 'true' : 'false'
    const is_Pplasku = formValues.is_Pplasku ? 'true' : 'false'
    selectedPage = selectedPage == null ? 0 : selectedPage.selected
    // Pagination size  - number of rows to fetch
    const rows = (selectedPage + 1) * formValues.adminSalaryPageSize

    // Always request {rows} number of records from the first page with 0 offset.
    // This avoids real time data issues with offset based pagination. New records are
    // always at the start of the first page and old records get pushed down to newer pages.
    // This method is implemented as performance is very fast for initial set of pages and
    // slowness is encountered only if we move to hundreds of pages.
    // (worst case running time is while navigating to the last page without any filters enabled, i.e. fetch of all the data in the system)

    const url = `${API_SERVER}/SearchSalaries?rows=${rows}&has_yel_filter=${has_yel}&has_ulosotto_filter=${has_ulosotto}&is_Pplasku=${is_Pplasku}`

    let body
    if (formValues === undefined) {
      body = {}
    } else {
      let start_date
      if (formValues.start_date) {
        start_date = formatFiToISO(
          new DateTimeFormat('fi', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
          })
            .format(new Date(formValues.start_date))
            .split('.')
        )
      }

      let end_date
      if (formValues.end_date) {
        end_date = formatFiToISO(
          new DateTimeFormat('fi', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
          })
            .format(new Date(formValues.end_date))
            .split('.')
        )
      }

      if (
        formValues.yearSelect &&
        (formValues.start_date === undefined ||
          formValues.start_date === null) &&
        formValues.yearSelect &&
        (formValues.end_date === undefined || formValues.end_date === null)
      ) {
        start_date = formatFiToISO(
          new DateTimeFormat('fi', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
          })
            .format(new Date(`January 01, ${formValues.yearSelect}`))
            .split('.')
        )

        end_date = formatFiToISO(
          new DateTimeFormat('fi', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
          })
            .format(new Date(`December 31, ${formValues.yearSelect}`))
            .split('.')
        )
      }

      body = {
        id: formValues.salaryId,
        firstname: formValues.firstname,
        start_date: start_date,
        end_date: end_date,
        Status: formValues.status,
        userinfo: {
          ssn: formValues.socialID,
          email: formValues.email,
          yelselect: formValues.yelSelect
        }
      }
    }

    const result = yield call(apiManualPost, url, JSON.stringify(body))

    const wages = []

    result[Symbol.iterator] = function* () {
      const keys = Reflect.ownKeys(this)
      for (const key of keys) {
        yield this[key]
      }
    }
    const data = JSON.parse(result.data)

    data.Salaries.forEach((salary) => {
      /* we need to adjust take_home_pay, ulosotto_sum_govpay and manual_sum_govpay values because to this potential scenario:
        1. user has ulosotto checkbox selected (in admin user panel)
        2. admin adds ulosotto amount in form, which causes to take_home_pay to change value (take_home_pay - manual_sum_govpay)
        3. admin changes user's ulosotto -> manual ulosotto in user panel
        4. take_home_pay is returned from server with the value still reduced by manual_ulosotto.
      */
      if (salary.status === 'processing') {
        if (salary.ismanualgovpay && salary.ulosotto_sum_govpay > 0) {
          salary.take_home_pay =
            salary.take_home_pay + salary.ulosotto_sum_govpay
          salary.ulosotto_sum_govpay = 0
        }

        if (salary.isgovpay && salary.manual_sum_govpay > 0) {
          salary.take_home_pay = salary.take_home_pay + salary.manual_sum_govpay
          salary.manual_sum_govpay = 0
        }
      }

      wages.push(salary)
    })

    var salarySearchSummary = {
      total_gross_salary: 0,
      total_tax_cost: 0,
      total_mileage_allowance: 0,
      total_daily_allowance: 0,
      total_service_cost: 0,
      total_social_contribution: 0,
      total_take_home_pay: 0,
      total_ulosotto_sum: 0,
      total_reimbursment_cost: 0,
      total_yel_cost: 0,
      expenses: {
        total_vat_amount: 0,
        sum_incl_vat_24: 0,
        sum_incl_vat_14: 0,
        sum_incl_vat_10: 0,
        sum_incl_vat_0: 0
      }
    }
    // Call to API to fetch the summary for salaries if filters are changed.
    if (refreshSearch) {
      const summaryUrl = `${API_SERVER}/SearchSalarySummary?has_yel_filter=${has_yel}&has_ulosotto_filter=${has_ulosotto}&is_Pplasku=${is_Pplasku}`
      var salarySummaryResponse = yield call(
        apiManualPost,
        summaryUrl,
        JSON.stringify(body)
      )
      // Parsing the response into state variable structure
      salarySummaryResponse = JSON.parse(salarySummaryResponse.data)

      var total_vat_amount = 0
      // Total expenses including vat grouped by vat percentages
      var total_expese_incl_vat = {
        0: 0,
        10: 0,
        14: 0,
        24: 0,
        25.5: 0
      }
      salarySummaryResponse.expense_vat_summary.forEach((summary_row) => {
        total_expese_incl_vat[summary_row['vat']] =
          summary_row['toatl_expense_incl_vat']
        total_vat_amount +=
          summary_row['toatl_expense_incl_vat'] -
          summary_row['total_expense_without_vat']
      })
      salarySearchSummary = {
        ...salarySummaryResponse.summary[0],
        expenses: {
          total_vat_amount: total_vat_amount,
          sum_incl_vat_25_5: total_expese_incl_vat[25.5],
          sum_incl_vat_24: total_expese_incl_vat[24],
          sum_incl_vat_14: total_expese_incl_vat[14],
          sum_incl_vat_10: total_expese_incl_vat[10],
          sum_incl_vat_0: total_expese_incl_vat[0]
        }
      }
    }
    yield put(
      searchAdminWagesSuccess(
        wages,
        data.Total_Count,
        selectedPage,
        refreshSearch,
        salarySearchSummary,
        formValues.adminSalaryPageSize
      )
    )

    yield put(closeLoadSalaryItems())

    yield put(closeAdminSalaryFormsSuccess())

    // PI-296 Fetching all records when month is searched
    if (
      wages.length > 0 &&
      formValues.start_date !== undefined &&
      formValues.end_date !== undefined
    ) {
      const allRowsUrl = `${API_SERVER}/SearchSalaries?rows=${data.Total_Count}&has_yel_filter=${has_yel}&has_ulosotto_filter=${has_ulosotto}&is_Pplasku=${is_Pplasku}`
      const resultAllRows = yield call(
        apiManualPost,
        allRowsUrl,
        JSON.stringify(body)
      )

      const allSalariesSearch = []

      resultAllRows[Symbol.iterator] = function* () {
        const keys = Reflect.ownKeys(this)
        for (const key of keys) {
          yield this[key]
        }
      }
      const resultAllRowsParse = JSON.parse(resultAllRows.data)
      resultAllRowsParse.Salaries.forEach((el) => {
        if (el.status === 'processing') {
          if (el.ismanualgovpay && el.ulosotto_sum_govpay > 0) {
            el.take_home_pay = salary.take_home_pay + salary.ulosotto_sum_govpay
            el.ulosotto_sum_govpay = 0
          }

          if (el.isgovpay && el.manual_sum_govpay > 0) {
            el.take_home_pay = salary.take_home_pay + salary.manual_sum_govpay
            el.manual_sum_govpay = 0
          }
        }

        allSalariesSearch.push(el)
      })
      yield put(searchAdminAllSalaryRecarodsSuccess(allSalariesSearch))
    }
  } catch (e) {
    yield put(searchAdminWagesFailed(e))
    yield put(closeLoadSalaryItems())
  }
}

function* adminsearchIRSalaryInfoSaga({ formValues }) {
  try {
    const url = `${API_SERVER}/GetIRSalResults`
    let body
    if (formValues === undefined) {
      body = {}
    } else {
      let start_date
      if (formValues.start_date !== undefined) {
        start_date = formatFiToISO(
          new DateTimeFormat('fi', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
          })
            .format(new Date(formValues.start_date))
            .split('.')
        )
      }

      let end_date
      if (formValues.end_date !== undefined) {
        end_date = formatFiToISO(
          new DateTimeFormat('fi', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
          })
            .format(new Date(formValues.end_date))
            .split('.')
        )
      }

      body = {
        id: formValues.salaryId,
        firstname: formValues.firstname,
        start_date: start_date,
        end_date: end_date
      }
    }

    const result = yield call(apiManualPost, url, JSON.stringify(body))

    const wages = []

    result[Symbol.iterator] = function* () {
      const keys = Reflect.ownKeys(this)
      for (const key of keys) {
        yield this[key]
      }
    }

    for (const wage of JSON.parse(result.data)) {
      wages.push(wage)
    }
    yield put(searchAdminIRWagesSuccess(wages))
  } catch (e) {
    yield put(searchAdminIRWagesFailed(e))
  }
}

function* adminUserExpandSaga({ expanded, uuid }) {
  try {
    if (!expanded) {
      yield put(expandAdminUserFalse(uuid))
    } else {
      const getUserUrl = `${API_SERVER}/GetUserContactDetails`
      const userBody = JSON.stringify({ uuid: uuid })
      const userResult = yield call(apiManualPost, getUserUrl, userBody)
      const result = { ...userResult }
      if (result.age_group === null) result.age_group = ''
      const parsedUser = JSON.parse(userResult.data)

      const url = `${API_SERVER}/GetTaxCard`
      const body = {
        uuid: uuid
      }
      const taxCardResult = yield call(apiManualPost, url, JSON.stringify(body))
      const parsedTaxCard = JSON.parse(taxCardResult.data)
      const taxCard =
        parsedTaxCard.length > 0
          ? intersection(parsedTaxCard[0], taxCardDefaultValues)
          : null

      // KAS-344 getting user's industry tax card info
      const getIndustryTaxUrl = `${API_SERVER}/GetUserDetailsTaxID`
      const industryTaxResult = yield call(
        apiManualPost,
        getIndustryTaxUrl,
        userBody
      )

      const industryTaxResultParse = JSON.parse(industryTaxResult.data)

      yield put(
        expandAdminUserTrue(parsedUser, taxCard, industryTaxResultParse)
      )
    }
  } catch (e) {
    console.warn(e)
  }
}

function* adminInvoiceExpandSaga({
  expanded,
  invoice_id,
  partial_invoice_id,
  uuid
}) {
  try {
    if (!expanded) {
      yield put(expandAdminInvoiceFalse(invoice_id, partial_invoice_id, uuid))
    } else {
      const url = `${API_SERVER}/GetInvoiceByInvoiceID`

      const body = JSON.stringify({
        invoice_id: invoice_id,
        partial_invoice_id: partial_invoice_id,
        uuid: uuid
      })
      const result = yield call(apiManualPost, url, body)
      const invoiceResult = JSON.parse(result.data)[0]

      let dueInvoices = invoiceResult.Invoice[0].dueInvoices
      let dueInvoiceIds = dueInvoices.split(',')

      if (dueInvoiceIds.length == 1 && dueInvoiceIds[0] == '') {
        dueInvoiceIds[0] = invoice_id
      }

      if (invoiceResult) {
        yield put(expandAdminInvoiceTrue(invoiceResult, dueInvoiceIds))
      }
    }
  } catch (e) {
    console.warn(e)
  }
}

//Add invoice, update invoice
function* adminInvoiceUpdateSaga({ formValues }) {
  try {
    const adminInvoiceEdit = store.getState().admin.adminInvoiceEdit
    const loggedInEmail = store.getState().client.user.data[1]

    let partial_amount_received = parseFloat(
      formValues.partial_amount_received
        .toString()
        .replace(/,/g, '.')
        .replace(/\s/g, '')
    )

    const addInvoiceUrl = `${API_SERVER}/AddPartialInvoice`
    const updateInvoiceUrl = `${API_SERVER}/UpdateInvoice`

    const body = JSON.parse(
      JSON.stringify({
        delivery_method: adminInvoiceEdit.delivery_method,
        customer_type: adminInvoiceEdit.customer_type,
        customer_id: adminInvoiceEdit.customer_id,
        country: adminInvoiceEdit.country,
        company_name: adminInvoiceEdit.company_name,
        business_id: adminInvoiceEdit.business_id,
        person_to_contact: adminInvoiceEdit.person_to_contact,
        person_to_contact_email: adminInvoiceEdit.person_to_contact_email,
        delivery_address: adminInvoiceEdit.delivery_address,
        zip_code: adminInvoiceEdit.zip_code,
        city: adminInvoiceEdit.city,
        web_invoice: adminInvoiceEdit.web_invoice,
        finvoice_operator: adminInvoiceEdit.finvoice_operator,
        person_to_quick_pay_email: adminInvoiceEdit.person_to_quick_pay_email,
        uuid: adminInvoiceEdit.Invoice[0].uuid,
        Invoice: [
          {
            userEmail: adminInvoiceEdit.user_email,
            description: adminInvoiceEdit.Invoice[0].description,
            invoice_reference: adminInvoiceEdit.Invoice[0].invoice_reference,
            billing_date: adminInvoiceEdit.Invoice[0].billing_date,
            due_date: formValues.due_date_field,
            remindersent: adminInvoiceEdit.Invoice[0].ReminderSent,
            overdue: adminInvoiceEdit.Invoice[0].overdue,
            invoice_price_selection:
              adminInvoiceEdit.Invoice[0].invoice_price_selection === true
                ? 1
                : 0,
            total_sum: adminInvoiceEdit.Invoice[0].total_sum,
            vat_select: adminInvoiceEdit.Invoice[0].vat_select,
            building_service:
              adminInvoiceEdit.Invoice[0].vat_select === 'vat_0_builders'
                ? true
                : false,
            instant_payment: adminInvoiceEdit.Invoice[0].instant_payment,
            invoice_id: adminInvoiceEdit.Invoice[0].invoice_id,
            partial_invoice_id: adminInvoiceEdit.Invoice[0].partial_invoice_id,
            status: adminInvoiceEdit.Invoice[0].status,
            invoice_lang: adminInvoiceEdit.Invoice[0].invoice_lang,
            notes: formValues.notes,
            rows: adminInvoiceEdit.Invoice[0].rows,
            document: [],
            GroupInvoice: adminInvoiceEdit.Invoice[0].is_group_invoice
              ? adminInvoiceEdit.Invoice[0].groupInvoiceRow
              : []
          }
        ]
      })
    )

    const bodyAddPartialInvoice = JSON.stringify({
      invoice_id: adminInvoiceEdit.Invoice[0].invoice_id,
      partial_invoice_id: adminInvoiceEdit.Invoice[0].partial_invoice_id,
      uuid: adminInvoiceEdit.Invoice[0].uuid,
      base_invoice_id: adminInvoiceEdit.Invoice[0].invoice_id,
      status: 22,
      sended_by: loggedInEmail,
      userEmail: adminInvoiceEdit.user_email,
      partial_amount_received: partial_amount_received,
      due_date:
        partial_amount_received < adminInvoiceEdit.Invoice[0].total_sum
          ? formValues.due_date_field
          : adminInvoiceEdit.Invoice[0].due_date,
      duedatefee: !!formValues.due_date_fee ? DUE_DATE_FEE : 0,
      partialpayfee: !!formValues.partial_pay_fee ? PARTIAL_PAY_FEE : 0,
      interestfee: !!formValues.interest_fee ? INTEREST_FEE : 0,
      invoice_lang: adminInvoiceEdit.Invoice[0].invoice_lang,
      notes: formValues.notes
    })

    if (
      formValues.send_new_invoice ||
      formValues.send_qp_admin_invoice ||
      adminInvoiceEdit.Invoice[0].status === 21 ||
      adminInvoiceEdit.Invoice[0].status === 22
    ) {
      yield put(adminSendNewInvoiceSuccess())
      const result = yield call(
        apiManualPost,
        addInvoiceUrl,
        bodyAddPartialInvoice
      )
      if (result.data.includes('Invoice Pdf sent successfully')) {
        yield put(adminGeneratePDFSuccess())
      } else {
        yield put(adminGeneratePDFFailed(result))
      }
    } else {
      yield call(apiManualPost, updateInvoiceUrl, JSON.stringify(body))
    }
    yield put(closeAdminInvoiceFormsSuccess())
    yield put(updateAdminTable())
  } catch (e) {
    console.warn(e)
  }
}

function* showLatestInvoicePDFSaga({ Id, uuid, base_invoice_id, base_uuid }) {
  try {
    const adminInvoiceEdit = store.getState().admin.adminInvoiceEdit

    let dueInvoices = adminInvoiceEdit.Invoice[0].dueInvoices
    let dueInvoiceIds = dueInvoices.split(',')

    if (dueInvoiceIds.length > 1) {
      const url = `${API_SERVER}/GetInvoiceByInvoiceID`
      if (Id == base_invoice_id) {
        const body = JSON.stringify({
          uuid: base_uuid,
          invoice_id: Id
        })
        const result = yield call(apiManualPost, url, body)
        const resultParsed = JSON.parse(result.data)[0]
        if (resultParsed.Invoice[0].ReminderSent === 1) {
          yield put(showReminderInvoicePDF(`${base_uuid}$$${Id}`))
        } else {
          yield put(showInvoicePDF(`${base_uuid}$$${Id}`))
        }
      } else {
        const body = JSON.stringify({
          uuid: uuid,
          invoice_id: Id
        })
        const result = yield call(apiManualPost, url, body)
        const resultParsed = JSON.parse(result.data)[0]
        if (resultParsed.Invoice[0].ReminderSent === 1) {
          yield put(showReminderInvoicePDF(`${uuid}$$${Id}`))
        } else {
          yield put(showInvoicePDF(`${uuid}$$${Id}`))
        }
      }
    } else if (adminInvoiceEdit.Invoice[0].ReminderSent === 1) {
      yield put(showReminderInvoicePDF(`${uuid}$$${Id}`))
    } else {
      yield put(showInvoicePDF(`${uuid}$$${Id}`))
    }
  } catch (error) {
    console.log(error)
  }
}

function* adminUserUpdateSaga({ formValues }) {
  try {
    let yelSelect
    if (formValues.yelSelect === 'Maksan YEL-vakuutuksen itse') {
      yelSelect = 'yel_self'
    } else if (
      formValues.yelSelect === 'Maksetaan YEL-vakuutus tulojen mukaan 24,10 %'
    ) {
      yelSelect = 'yel_recommended'
    } else if (
      formValues.yelSelect === 'Maksan minimi YEL-vakuutuksen (9010,28 €)'
    ) {
      yelSelect = 'yel_minimum'
    } else {
      yelSelect = 'no_yel'
    }

    const invoiceUrl = `${API_SERVER}/UpdateUserContactDetails`
    const body = JSON.stringify({
      uuid: formValues.uuid,
      tax_percentage: parseFloat(
        formValues.tax_percentage.toString().replace(/,/g, '.')
      ).toString(),
      service_payment: parseFloat(
        formValues.service_payment.toString().replace(/,/g, '.')
      ).toString(),
      firstname: formValues.firstname,
      lastname: formValues.lastname,
      account_number: formValues.account_number,
      job_title: formValues.job_title,
      phone: formValues.phone,
      market_name: formValues.market_name,
      city: formValues.city,
      address: formValues.address,
      zip_code: formValues.zip_code,
      ssn: formValues.ssn,
      //profession: formValues.profession.substring(0, formValues.profession.lastIndexOf(' ')),
      yel_percentage: formValues.yel_percentage,
      yel_income: formValues.yel_income,
      yelSelect: yelSelect,
      firsttime_enterprenuer: formValues.firsttime_enterprenuer,
      age_group: formValues.age_group,
      isgovpay: formValues.isgovpay,
      ismanualgovpay: formValues.ismanualgovpay,
      isnormalgovpay: formValues.isnormalgovpay,
      isbruttogovpay: formValues.isbruttogovpay,
      maxmonthlygovpay: formValues.maxmonthlygovpay,
      useMarketName: formValues.useMarketName,
      notes: formValues.notes,
      salary_payment_option: formValues.salary_payment_option,
      //salary_payment_option: 'manual_pay',
      field_work: formValues.field_work,
      tax_card: formValues.tax_card,
      withdrawal_account_number: formValues.withdrawal_account_number,
      withdrawal_reference_number: formValues.withdrawal_reference_number,
      payment_ban_number: formValues.payment_ban_number
    })

    const result = yield call(apiManualPost, invoiceUrl, body)

    if (result.data === 'User contact information updated successfully!') {
      yield put(updateAdminUserResult())
    } else if (result.data === 'ssn already exist') {
      // KAS-361 SSN duplicated
      yield put(ssnDuplicate(result.data))
    } else {
      yield put(updateAdminUserResultFailed())
    }

    //Huong - kas344 Update industry tax card
    if (formValues?.taxCard_number) {
      const adminUserSearchRows = store.getState().admin.userSearchRows
      const userUpdated = adminUserSearchRows.filter(
        (el) => el.uuid === formValues.uuid
      )
      const TypeValtticard =
        formValues.construction === true && formValues.shipbuilding === false
          ? 'construction'
          : formValues.construction === false &&
            formValues.shipbuilding === true
          ? 'shipbuilding'
          : formValues.construction === true && formValues.shipbuilding === true
          ? 'construction/shipbuilding'
          : ''
      const industryTaxUrl = `${API_SERVER}/UpdateUserIdentityTaxID`
      if (formValues?.taxCard_inputPicture) {
        // Tax card picture is updated
        const inputFile = formValues?.taxCard_inputPicture[0]
        const bodyUpdateTaxCard_1 = {
          firstname: formValues.firstname,
          lastname: formValues.lastname,
          ssn: formValues.ssn,
          phone: formValues.phone,
          TaxNumber: formValues.taxCard_number,
          CardDeliveryAddress: formValues.taxCard_address,
          ApartmentNumber: formValues?.taxCard_unit
            ? formValues?.taxCard_unit
            : '',
          PostalCode: formValues.taxCard_zip_code,
          city: formValues.taxCard_city,
          TypeValtticard: TypeValtticard
        }

        const channel = yield call(
          createUploadFileChannel,
          industryTaxUrl,
          inputFile,
          bodyUpdateTaxCard_1,
          formValues.uuid
        )

        while (true) {
          const { err, success, data } = yield take(channel)
          if (err) {
            yield put(adminUpdateIndustryTaxCardFailed(err))
          }
          if (success) {
            yield put(adminUpdateIndustryTaxCardSuccess(data))
          }
          if (
            data !== undefined &&
            JSON.parse(data) === 'User tax card details updated successfully'
          ) {
            // Calling generate industry tax card PDF and send to asiskaspalvelu@kassvirtanen.fi
            const generatePDFUrl = `${API_SERVER}/GenerateUserTaxDetailsPDF`
            const generatePDFBody = JSON.stringify({
              uuid: formValues.uuid,
              firstname: formValues.firstname,
              lastname: formValues.lastname,
              email: userUpdated[0].email,
              TypeValtticard: TypeValtticard
            })
            const generatePDFResult = yield call(
              apiManualPost,
              generatePDFUrl,
              generatePDFBody
            )
            if (generatePDFResult.data) {
              yield put(generateIndustryTaxPDFSuccess(generatePDFResult.data))
            } else {
              yield put(generateIndustryTaxPDFFailed())
            }
          }
        }
      } else {
        // Tax card picture is not updated
        const formTaxCardUnit = formValues?.taxCard_unit
          ? formValues?.taxCard_unit
          : ''
        const userFormData = userUpdated[0].expandData

        // Any field values at tax card is changed, PDF mail is sent
        const isSendPDF =
          formValues.taxCard_number !== userFormData.taxCard_number ||
          formTaxCardUnit !== userFormData.taxCard_unit ||
          formValues.taxCard_zip_code !== userFormData.taxCard_zip_code ||
          formValues.taxCard_address !== userFormData.taxCard_address ||
          formValues.taxCard_city !== userFormData.taxCard_city ||
          formValues.construction !== userFormData.construction ||
          formValues.shipbuilding !== userFormData.shipbuilding
            ? true
            : false

        const bodyUpdateTaxCard_2 = {
          firstname: formValues.firstname,
          lastname: formValues.lastname,
          ssn: formValues.ssn,
          phone: formValues.phone,
          TaxNumber: formValues.taxCard_number,
          CardDeliveryAddress: formValues.taxCard_address,
          ApartmentNumber: formValues?.taxCard_unit
            ? formValues?.taxCard_unit
            : '',
          PostalCode: formValues.taxCard_zip_code,
          city: formValues.taxCard_city,
          TypeValtticard: TypeValtticard,
          document: {
            uuid: formValues.uuid,
            document_id: userUpdated[0].expandData.document_id,
            filename: userUpdated[0].expandData.fileName,
            filetype: userUpdated[0].expandData.fileType,
            data: userUpdated[0].expandData.filePath
          }
        }
        const channel_2 = yield call(
          createUploadFileChannel,
          industryTaxUrl,
          null,
          bodyUpdateTaxCard_2,
          formValues.uuid
        )
        while (true) {
          const { err, success, data } = yield take(channel_2)
          if (err) {
            yield put(adminUpdateIndustryTaxCardFailed(err))
          }
          if (success) {
            yield put(adminUpdateIndustryTaxCardSuccess(data))
          }
          if (
            data !== undefined &&
            JSON.parse(data) === 'User tax card details updated successfully' &&
            isSendPDF
          ) {
            // Calling generate industry tax card PDF and send to asiskaspalvelu@kassvirtanen.fi
            const generatePDFUrl = `${API_SERVER}/GenerateUserTaxDetailsPDF`
            const generatePDFBody = JSON.stringify({
              uuid: formValues.uuid,
              firstname: formValues.firstname,
              lastname: formValues.lastname,
              email: userUpdated[0].email,
              TypeValtticard: TypeValtticard
            })
            const generatePDFResult = yield call(
              apiManualPost,
              generatePDFUrl,
              generatePDFBody
            )
            if (generatePDFResult.data) {
              yield put(generateIndustryTaxPDFSuccess(generatePDFResult.data))
            } else {
              yield put(generateIndustryTaxPDFFailed())
            }
          }
        }
      }
    } else {
      yield put(adminUpdateIndustryTaxCardSuccess())
    }
  } catch (e) {
    console.warn(e)
    yield put(updateAdminUserResultFailed(e))
    yield put(adminUpdateIndustryTaxCardFailed(e))
  }
}

function* adminUpdateInvoiceStatusSaga({ invoice_id }) {
  try {
    const id = invoice_id.split('$$')
    const uuid = id[0]
    const inv_id = id[1]
    const inst_pay = id[2]
    const partial_inv_id = id[3]

    //Get Invoice Info
    const urlGetInvoice = `${API_SERVER}/GetInvoiceByInvoiceID`
    const bodyGetInvoice = JSON.stringify({
      invoice_id: inv_id,
      partial_invoice_id: partial_inv_id,
      uuid: uuid
    })

    const resultGetInvoice = yield call(
      apiManualPost,
      urlGetInvoice,
      bodyGetInvoice
    )
    const invoiceGetResult = JSON.parse(resultGetInvoice.data)

    let invStatus = invoiceGetResult[0].Invoice[0].status

    const url = `${API_SERVER}/UpdateInvoiceStatus`

    const body = JSON.stringify({
      uuid: uuid,
      invoice_id: inv_id,
      instant_payment: inst_pay,
      //Update AdminPerinassa, status 23 to AdminMaksettu, status 18, otherwise status Maksettu 2
      status: invStatus === 23 ? 18 : 2
    })

    const result = yield call(apiManualPost, url, body)

    if (result.data === 'Invoice status updated Successfully') {
      yield put(updateAdminInvoiceStatusSuccess(result.data))
    } else {
      console.warn(result.data)
    }
    yield put(updateAdminTable())
  } catch (e) {
    console.warn(e)
  }
}

function* adminUpdateInvoiceStatustoRejectedSaga() {
  try {
    const url = `${API_SERVER}/UpdateInvoiceStatus`
    const invoice_id = store.getState().admin.isToPayInvoiceId
    const id = invoice_id.split('$$')
    const uuid = id[0]
    const inv_id = id[1]
    const inst_pay = id[2]

    const body = JSON.stringify({
      uuid: uuid,
      invoice_id: inv_id,
      instant_payment: inst_pay,
      status: 4 //Hylätty
    })
    const result = yield call(apiManualPost, url, body)

    if (result.data === 'Invoice status updated Successfully') {
      yield put(updateAdminInvoiceStatusSuccess(result.data))
    } else {
      console.warn(result.data)
    }
    yield put(updateAdminTable())
  } catch (e) {
    console.warn(e)
  }
}

function* adminUpdateInvoiceStatustoLoanedSaga() {
  try {
    const url = `${API_SERVER}/UpdateInvoiceStatus`
    const invoice_id = store.getState().admin.isToPayInvoiceId

    const id = invoice_id.split('$$')
    const uuid = id[0]
    const inv_id = id[1]
    const inst_pay = id[2]

    const body = JSON.stringify({
      uuid: uuid,
      invoice_id: inv_id,
      instant_payment: inst_pay,
      status: 5 //Rahoitettu
    })
    const result = yield call(apiManualPost, url, body)

    if (result.data === 'Invoice status updated Successfully') {
      yield put(updateAdminInvoiceStatusSuccess(result.data))
    } else {
      console.warn(result.data)
    }
    yield put(updateAdminTable())
  } catch (e) {
    console.warn(e)
  }
}

function* adminUpdateInvoiceStatustoNotAcceptedSaga() {
  try {
    const url = `${API_SERVER}/UpdateInvoiceStatus`
    const invoice_id = store.getState().admin.isToPayInvoiceId
    const id = invoice_id.split('$$')
    const uuid = id[0]
    const inv_id = id[1]
    const inst_pay = id[2]

    const body = JSON.stringify({
      uuid: uuid,
      invoice_id: inv_id,
      instant_payment: inst_pay,
      status: 8 //Ei Hyväksytty
    })
    const result = yield call(apiManualPost, url, body)

    if (result.data === 'Invoice status updated Successfully') {
      yield put(updateAdminInvoiceStatusSuccess(result.data))
    } else {
      console.warn(result.data)
    }
    yield put(updateAdminTable())
  } catch (e) {
    console.warn(e)
  }
}

function* adminUpdateInvoiceStatustoPaidAndNewInvoiceSaga() {
  try {
    const url = `${API_SERVER}/AddNewInvoice`
    const invoice_id = store.getState().admin.isToPayInvoiceId

    const id = invoice_id.split('$$')
    const uuid = id[0]
    const inv_id = id[1]

    const body = JSON.stringify({
      uuid: uuid,
      invoice_id: inv_id
    })

    const result = yield call(apiManualPost, url, body)
    const resultParsed = JSON.parse(result.data)

    //Calling GenerateInvoicePDF API....
    const generateInvoicePDFUrl = `${API_SERVER}/GenerateInvoicePDF`
    const generateInvoicePDFBody = JSON.stringify({
      invoice_id: resultParsed[0].invoice_id,
      uuid: uuid
    })
    const generateInvoicePDFResult = yield call(
      apiManualPost,
      generateInvoicePDFUrl,
      generateInvoicePDFBody
    )

    if (
      generateInvoicePDFResult.data.message.includes(
        'Invoice Pdf sent successfully'
      )
    ) {
      yield put(updateAdminTable())
    }
  } catch (e) {
    console.warn(e)
  }
}

// Function used when invoice status is changed or added
function* adminUpdateInvoiceStatustoNewSaga({ status, notes = null }) {
  try {
    const url = `${API_SERVER}/UpdateInvoiceStatus`
    const invoice_id = store.getState().admin.isToPayInvoiceId
    const id = invoice_id.split('$$')
    const uuid = id[0]
    const inv_id = id[1]
    const inst_pay = id[2]

    const body = JSON.stringify({
      uuid: uuid,
      invoice_id: inv_id,
      instant_payment: inst_pay,
      status: status,
      notes: notes // Optional notes parameter (defaults to null)
    })

    const result = yield call(apiManualPost, url, body)

    if (result.data === 'Invoice status updated Successfully') {
      yield put(updateAdminInvoiceStatusSuccess(result.data))
    } else {
      console.warn(result.data)
    }
    yield put(updateAdminTable())
  } catch (e) {
    console.warn(e)
  }
}

function* adminUpdateInvoiceStatustoPerinnassaSaga({ invoice_id }) {
  try {
    const url = `${RESONIA_API_SERVER}/SendInvoiceToResonia`
    const id = invoice_id.split('$$')
    const uuid = id[0]
    const inv_id = id[1]
    const partial_inv_id = id[2]

    //Get Invoice Info
    const urlGetInvoice = `${API_SERVER}/GetInvoiceByInvoiceID`
    const bodyGetInvoice = JSON.stringify({
      invoice_id: inv_id,
      partial_invoice_id: partial_inv_id,
      uuid: uuid
    })
    const result = yield call(apiManualPost, urlGetInvoice, bodyGetInvoice)
    const invoiceResult = JSON.parse(result.data)

    //Resonia delivery method
    if (invoiceResult[0].delivery_method == 'Kirjeposti') {
      invoiceResult[0].delivery_method = 'Posti'
    }

    //Finvoice
    if (
      invoiceResult[0].web_invoice == undefined &&
      invoiceResult[0].finvoice_operator == undefined
    ) {
      invoiceResult[0].web_invoice = ''
      invoiceResult[0].finvoice_operator = ''
    }

    //company_type workaround
    let customerType

    if (invoiceResult[0].customer_type == 'private_person') {
      customerType = 'Yksityishenkilö'
    } else if (invoiceResult[0].customer_type == 'company') {
      customerType = 'Yritys'
    } else {
      customerType = 'Yritys'
    }

    let countryCode = invoiceResult[0].country
    if (
      invoiceResult[0].country == 'Viro' ||
      invoiceResult[0].country == 'Eesti'
    ) {
      countryCode = 'Estonia'
    }

    let invStatus = invoiceResult[0].Invoice[0].status

    let body = JSON.stringify({
      user_type: 'Yritys',
      user_contact_name: 'Invosy Oy',
      company_name: 'Invosy Oy',
      business_id: '3413106-8',
      phone: '020 734 6903',
      email: 'asiakaspalvelu@invosy.com',
      bank_name: 'Nordea Pankki',
      account_number: 'FI31 1745 3000 3174 63',
      address: 'Salomonkatu 17 B',
      zip_code: '100',
      city: 'HELSINKI',
      customer: [
        {
          person_to_contact: invoiceResult[0].person_to_contact,
          person_to_contact_email: invoiceResult[0].person_to_contact_email,
          delivery_address: invoiceResult[0].delivery_address,
          zip_code: invoiceResult[0].zip_code,
          city: invoiceResult[0].city,
          country: countryCode,
          customer_type: customerType,
          company_name: invoiceResult[0].company_name,
          business_id: invoiceResult[0].business_id,
          delivery_method: invoiceResult[0].delivery_method,
          //Finvoice
          web_invoice: invoiceResult[0].web_invoice,
          finvoice_operator: invoiceResult[0].finvoice_operator,
          invoice: [
            {
              debt_billing_date: invoiceResult[0].Invoice[0].billing_date,
              debt_invoice_number: invoiceResult[0].Invoice[0].invoice_id,
              amount: invoiceResult[0].Invoice[0].total_sum,
              debt_due_date: invoiceResult[0].Invoice[0].due_date,
              invoice_justification: 'Invosy Debt Collection',
              status: 2,
              interest_percent: 7,
              invoice_lang: invoiceResult[0].Invoice[0].invoice_lang,
              reminderfee: invoiceResult[0].Invoice[0].reminderfee,
              debt_collection_fee:
                invoiceResult[0].Invoice[0].debt_collection_fee,
              debt_reference_number: invoiceResult[0].Invoice[0].referencenumber
            }
          ]
        }
      ]
    })

    const result1 = yield call(apiManualPost, url, body)

    if (result1.data === 'Invoice added and sent to the customer') {
      const urlUpdateInvoice = `${API_SERVER}/UpdateInvoiceStatus`

      const body = JSON.stringify({
        uuid: uuid,
        invoice_id: inv_id,
        instant_payment: '',
        status: invStatus === 17 ? 23 : 9
      })

      const result = yield call(apiManualPost, urlUpdateInvoice, body)
      if (result.data === 'Invoice status updated Successfully') {
        yield put(updateAdminInvoiceStatusSuccess(result.data))
      } else {
        console.warn(result.data)
      }
      yield put(updateAdminTable())
    }
  } catch (error) {
    console.warn(error)
  }
}

function* noPikapalkkaSaga({ payload }) {
  try {
    const invoice_id = store.getState().admin.isToPayInvoiceId
    const url = `${API_SERVER}/UpdateInvoiceStatus`
    const id = invoice_id.split('$$')
    const uuid = id[0]
    const inv_id = id[1]

    const body = JSON.stringify({
      uuid: uuid,
      invoice_id: inv_id,
      instant_payment: payload === true ? '' : 'quick_pay',
      status: payload === true ? 1 : 3 //Lähetetty vs Käsittelyssä
    })
    const result = yield call(apiManualPost, url, body)

    if (result.data === 'Invoice status updated Successfully') {
      yield put(updateAdminInvoiceStatusSuccess(result.data))
    } else {
      console.warn(result.data)
    }
    yield put(updateAdminTable())
  } catch (e) {
    console.warn(e)
  }
}

//Single Payment
/* function* importKassavirtanenSalariesSaga({ selected }) {
  try {
    const url = `${API_SERVER}/UpdateSalaryStatus`
    const sal_id = selected.split('$$')
    const uuid = sal_id[0]
    const salary_id = sal_id[1]
    const body = JSON.stringify({
      uuid: uuid,
      id: salary_id,
      Status: 'paid'
    })
    const result = yield call(apiManualPost, url, body)
    const ImportKassavirtanenSalariesUrl = `${API_SERVER}/ImportKassavirtanenSalaries`
    const ImportKassavirtanenSalariesBody = JSON.stringify({
      uuid: uuid,
      id: salary_id
    })

    if (result.data === 'Salary status updated Successfully') {
      yield put(updateAdminSalaryStatusSuccess(result.data))
      yield call(apiBlobPost, ImportKassavirtanenSalariesUrl, ImportKassavirtanenSalariesBody)
    } else {
      console.warn(result.data)
    }
    yield put(searchAdminWages())
  } catch (e) {
    console.warn(e)
  }
} */

//Batch Payment

function* importKassavirtanenSalariesSaga({ selected }) {
  try {
    const selectedIds = selected
    let b = selectedIds.reverse()

    const filteredArr = b.reduce((acc, current) => {
      const x = acc.find(
        (item) =>
          `${item.uuid}$$${item.id}` === `${current.uuid}$$${current.id}`
      )
      if (!x) {
        return acc.concat([current])
      } else {
        return acc
      }
    }, [])

    let finalSalaryIds = []
    finalSalaryIds = filteredArr.filter((item) => item.isChecked !== false)

    let bodyToSend = finalSalaryIds.map(({ uuid, id }) => ({ uuid, id }))
    const body = JSON.stringify(bodyToSend)
    const newSalaryRows = []

    for (let row of bodyToSend) {
      newSalaryRows.push({ ...row, Status: 'paid', isManualPay: false })
    }

    let UpdatedSalRows
    UpdatedSalRows = JSON.stringify(newSalaryRows)

    const urlUpdateSalaryStatus = `${API_SERVER}/UpdateSalaryStatus`

    const resultUpdateStatus = yield call(
      apiManualPost,
      urlUpdateSalaryStatus,
      UpdatedSalRows
    )

    const ImportKassavirtanenSalariesUrl = `${API_SERVER}/ImportKassavirtanenSalaries`

    if (resultUpdateStatus.data === 'Salary status updated Successfully') {
      yield put(updateAdminSalaryStatusSuccess(resultUpdateStatus.data))
      yield call(apiBlobPost, ImportKassavirtanenSalariesUrl, body)
    }
    // Refresh search after updating
    yield put(updateAdminTable())
  } catch (e) {
    console.warn(e)
  }
}

//Manual Pay Salaries
function* manualPaySalariesSaga({ selected }) {
  try {
    const selectedIds = selected
    let b = selectedIds.reverse()

    const filteredArr = b.reduce((acc, current) => {
      const x = acc.find(
        (item) =>
          `${item.uuid}$$${item.id}` === `${current.uuid}$$${current.id}`
      )
      if (!x) {
        return acc.concat([current])
      } else {
        return acc
      }
    }, [])

    let finalSalaryIds = []
    finalSalaryIds = filteredArr.filter((item) => item.isChecked !== false)

    let bodyToSend = finalSalaryIds.map(({ uuid, id }) => ({ uuid, id }))
    const body = JSON.stringify(bodyToSend)
    const newSalaryRows = []

    for (let row of bodyToSend) {
      newSalaryRows.push({ ...row, Status: 'paid', isManualPay: true })
    }

    let UpdatedSalRows
    UpdatedSalRows = JSON.stringify(newSalaryRows)

    const urlUpdateSalaryStatus = `${API_SERVER}/UpdateSalaryStatus`

    const resultUpdateStatus = yield call(
      apiManualPost,
      urlUpdateSalaryStatus,
      UpdatedSalRows
    )

    const ImportKassavirtanenSalariesUrl = `${API_SERVER}/ImportKassavirtanenSalaries`

    if (resultUpdateStatus.data === 'Salary status updated Successfully') {
      yield put(updateAdminSalaryStatusSuccess(resultUpdateStatus.data))
      yield call(apiBlobPost, ImportKassavirtanenSalariesUrl, body)
    }
    // Refresh search after updating
    yield put(updateAdminTable())
  } catch (e) {
    console.warn(e)
  }
}

//SendToIRSaga
function* salarySendToIRSaga({ selected }) {
  try {
    const selectedIds = selected

    let b = selectedIds.reverse()

    const filteredArr = b.reduce((acc, current) => {
      const x = acc.find(
        (item) =>
          `${item.uuid}$$${item.id}` === `${current.uuid}$$${current.id}`
      )
      if (!x) {
        return acc.concat([current])
      } else {
        return acc
      }
    }, [])

    let finalSalaryIds = []

    finalSalaryIds = filteredArr.filter((item) => item.isChecked !== false)

    let bodyToSend = finalSalaryIds.map(({ uuid, id }) => ({ uuid, id }))
    const body = JSON.stringify(bodyToSend)

    const salarySendIRUrl = `${API_SERVER}/AddWageReportToIR`
    const result = yield call(apiManualPost, salarySendIRUrl, body)

    if (result.data === 'Salaries submitted to IR successfully') {
      yield put(updateAdminSalaryStatusSuccess(result.data))
    } else {
      yield put(updateAdminIRFailed(result.data))
    }
    // Refresh search after updating
    yield put(updateAdminTable())
  } catch (e) {
    console.warn(e)
  }
}

//CancelIRSaga
function* cancelSalaryIRReportSaga({ selected }) {
  try {
    const selectedIds = selected

    let b = selectedIds.reverse()

    const filteredArr = b.reduce((acc, current) => {
      const x = acc.find(
        (item) =>
          `${item.uuid}$$${item.id}` === `${current.uuid}$$${current.id}`
      )
      if (!x) {
        return acc.concat([current])
      } else {
        return acc
      }
    }, [])

    let finalSalaryIds = []

    finalSalaryIds = filteredArr.filter((item) => item.isChecked !== false)

    let bodyToSend = finalSalaryIds.map(({ uuid, id }) => ({ uuid, id }))
    const body = JSON.stringify(bodyToSend)

    const salarySendIRUrl = `${API_SERVER}/SalaryCancelReportIR`
    const result = yield call(apiManualPost, salarySendIRUrl, body)

    if (result.data === 'Salaries IR report cancelled successfully') {
      yield put(updateAdminSalaryStatusSuccess(result.data))
    } else {
      yield put(updateAdminIRFailed(result.data))
    }
    // Refresh search after updating
    yield put(updateAdminTable())
  } catch (e) {
    console.warn(e)
  }
}

//Updatesalarystauts Maunaul IR
function* updateSalaryStatusIRSaga({ selected }) {
  try {
    const selectedIds = selected

    let b = selectedIds.reverse()

    const filteredArr = b.reduce((acc, current) => {
      const x = acc.find(
        (item) =>
          `${item.uuid}$$${item.id}` === `${current.uuid}$$${current.id}`
      )
      if (!x) {
        return acc.concat([current])
      } else {
        return acc
      }
    }, [])

    let finalSalaryIds = []

    finalSalaryIds = filteredArr.filter((item) => item.isChecked !== false)

    let bodyToSend = finalSalaryIds.map(({ uuid, id }) => ({ uuid, id }))

    const newSalaryRows = []

    for (let row of bodyToSend) {
      newSalaryRows.push({ ...row, Status: 'IRManual', isManualPay: false })
    }

    const body = JSON.stringify(newSalaryRows)

    const salarySendIRUrl = `${API_SERVER}/UpdateSalaryStatus`
    const result = yield call(apiManualPost, salarySendIRUrl, body)

    if (result.data === 'Salary status updated Successfully') {
      yield put(updateAdminSalaryStatusSuccess(result.data))
    } else {
      yield put(updateAdminIRFailed(result.data))
    }
    // Refresh search after updating
    yield put(updateAdminTable())
  } catch (e) {
    console.warn(e)
  }
}

//Batch Payment
function* adminUpdateSalaryStatusSaga({ id }) {
  try {
    yield put(loadSalaryItems())
    const url = `${PAYMENTS_API_SERVER}/${PAYMENTS_API_PATH_USERS}`
    const urlMainAccount = `${PAYMENTS_API_SERVER}/${PAYMENTS_API_PATH_MAIN_ACCOUNT}`
    const urlServiceAccount = `${PAYMENTS_API_SERVER}/${PAYMENTS_API_PATH_SERVICE_ACCOUNT}`
    const urlUlosotto = `${PAYMENTS_API_SERVER}/${PAYMENTS_API_PATH_ULOSOTTO}`

    const selectedSalaryIds = id
    let b = selectedSalaryIds.reverse()
    const filteredArr = b.reduce((acc, current) => {
      const x = acc.find(
        (item) =>
          `${item.uuid}$$${item.id}` === `${current.uuid}$$${current.id}`
      )
      if (!x) {
        return acc.concat([current])
      } else {
        return acc
      }
    }, [])
    let finalSalaryIds = []
    finalSalaryIds = filteredArr.filter((item) => item.isChecked !== false)

    const govpayTypes = [
      'govpay',
      'manual_govpay',
      'brutto_govpay',
      'normal_govpay'
    ]

    const { bodyToSend, bodyToSendUlosotto } = finalSalaryIds.reduce(
      (acc, salary) => {
        const { 
          uuid, 
          id, 
          Salary_type, 
          ulosotto_sum_govpay, 
          manual_sum_govpay,
          brutto_sum_govpay,
          normal_govpay_sum,
          withdrawal_account_number,
          withdrawal_reference_number
        } = salary

        const mappedSalary = { uuid, id }

        acc.bodyToSend.push(mappedSalary)

        if (
          govpayTypes.includes(Salary_type) &&
          withdrawal_account_number && 
          withdrawal_reference_number &&
          (
            ulosotto_sum_govpay > 0 || 
            manual_sum_govpay > 0 ||
            brutto_sum_govpay > 0 ||
            normal_govpay_sum > 0
          )
        ) {
          acc.bodyToSendUlosotto.push(mappedSalary)
        }

        return acc
      },
      { bodyToSend: [], bodyToSendUlosotto: [] }
    )

    const body = JSON.stringify(bodyToSend)
    const bodyUlosotto = JSON.stringify(bodyToSendUlosotto)

    const newSalaryRows = []
    for (let row of bodyToSend) {
      newSalaryRows.push({
        ...row,
        Status: store.getState().admin.Status,
        isManualPay: false
      })
    }
    const newSalMainAccountRows = []

    for (let row of bodyToSend) {
      newSalMainAccountRows.push({
        ...row,
        dedtstatus: store.getState().admin.Status,
        isManualPay: false
      })
    }

    const newSalUlosottoRows = []

    for (let row of bodyToSendUlosotto) {
      newSalUlosottoRows.push({
        ...row,
        bank_ulosotto_status: store.getState().admin.Status,
        isManualPay: false
      })
    }

    let UpdatedSalRows
    UpdatedSalRows = JSON.stringify(newSalaryRows)
    let UpdatedSalMainAccountRows
    UpdatedSalMainAccountRows = JSON.stringify(newSalMainAccountRows)


    let UpdatedSalUlosottoRows
    UpdatedSalUlosottoRows = JSON.stringify(newSalUlosottoRows)

    const urlUpdateSalaryStatus = `${API_SERVER}/UpdateSalaryStatus`
    const urlUpdateSalaryStatusMainAccount = `${API_SERVER}/UpdateSalaryStatusMainAccount`
    const urlUpdateSalaryStatusServiceAccount = `${API_SERVER}/UpdateSalaryServiceAccount`
    const urlUpdateSalaryStatusUlosotto = `${API_SERVER}/UpdateSalaryStatusUlosotto`

    try {
      const result = yield call(apiManualPost, url, body)

      if (
        result.data.message === 'Payment uploadfile executed successfully' ||
        result.data.message ===
          'Payment uploadfile executed successfully but database is not updated properly'
      ) {
        const resultUpdateStatus = yield call(
          apiManualPost,
          urlUpdateSalaryStatus,
          UpdatedSalRows
        )
        if (resultUpdateStatus.data === 'Salary status updated Successfully') {
          yield put(updateAdminSalaryStatusSuccess(result.data.message))
        }
      } else {
        yield put(updateAdminBankPaymentFailed(result.data.message))
      }
      //MainAccount
      const resultMainAccount = yield call(apiManualPost, urlMainAccount, body)
      if (
        resultMainAccount.data.message ===
          'Payment to main account uploadfile executed successfully but database is not updated properly' ||
        resultMainAccount.data.message ===
          'Payment to main account uploadfile executed successfully'
      ) {
        const resultUpdateStatus1 = yield call(
          apiManualPost,
          urlUpdateSalaryStatusMainAccount,
          UpdatedSalMainAccountRows
        )
        if (
          resultUpdateStatus1.data ===
          'Main account sal status updated successfully'
        ) {
          yield put(
            updateAdminSalaryStatusSuccess(resultMainAccount.data.message)
          )
        }
      } else if (
        resultMainAccount.data.message === 'Salary contain quick pay invoice'
      ) {
        yield put(updateAdminSalaryStatusSuccess(resultMainAccount.data.message))
      } else {
        yield put(updateAdminBankPaymentFailed(resultMainAccount.data.message))
      }
      //Service account
      const resultServiceAccount = yield call(
        apiManualPost,
        urlServiceAccount,
        body
      )
      if (
        resultServiceAccount.data.message ===
          'Payment to service account uploadfile executed successfully' ||
        resultServiceAccount.data.message ===
          'Payment to service account uploadfile executed successfully but database is not updated properly'
      ) {
        const resultUpdateStatus = yield call(
          apiManualPost,
          urlUpdateSalaryStatusServiceAccount,
          UpdatedSalRows
        )
        if (
          resultUpdateStatus.data ===
          'Service account sal status updated successfully'
        ) {
          yield put(
            updateAdminSalaryStatusSuccess(resultServiceAccount.data.message)
          )
        }
      } else {
        yield put(updateAdminBankPaymentFailed(resultServiceAccount.data.message))
      }
      yield put(closeLoadSalaryItems())
    } catch (e) {
      console.warn(e)
      yield put(updateAdminSalaryStatusFailed())
    }

    //Ulosotto
    if (bodyToSendUlosotto.length > 0) {
      try {
        const resultUlosotto = yield call(apiManualPost, urlUlosotto, bodyUlosotto)
        if (
            [
              'Ulosotto payment uploadfile executed successfully',
              'Ulosotto payment uploadfile executed successfully but database is not updated properly'
            ].includes(resultUlosotto.data.message)
        ) {
          const resultUpdateStatus2 = yield call(
            apiManualPost,
            urlUpdateSalaryStatusUlosotto,
            UpdatedSalUlosottoRows
          )
          if (
            resultUpdateStatus2.data ===
            'Ulosotto status updated successfully'
          ) {
            yield put(updateAdminSalaryStatusSuccess(resultUlosotto.data.message))
          }
        } else {
          yield put(updateAdminBankPaymentFailed(resultUlosotto.data.message))
        }
        // Refresh search after updating
        yield put(updateAdminTable())
      } catch (e) {
        console.warn(e)
        yield put(updateAdminSalaryStatusFailed())
      }
    }
    yield put(closeLoadSalaryItems())
  } catch (e) {
    yield put(closeLoadSalaryItems())
    console.warn(e)
  }
}

//Single Payment
/* function* adminUpdateSalaryStatusSaga({ id }) {
  try {
    const urlSalPayment = `${API_SERVER}/SalPaymentforUsers`
    const sal_id = id.split('$$')
    const uuid = sal_id[0]
    const salary_id = sal_id[1]
    const bodySalPayment = JSON.stringify({
      uuid: uuid,
      id: salary_id
    })

    const urlUpdateSalary = `${API_SERVER}/UpdateSalaryStatus`
    const bodyUpdateSalary = JSON.stringify({
      uuid: uuid,
      id: salary_id,
      Status: 'bankingprocess'
    })

    const result = yield call(apiManualPost, urlSalPayment, bodySalPayment)

    if (result.data === 'Payment Uploadfile executed successfully') {

      const resultUpdateStatus = yield call(apiManualPost, urlUpdateSalary, bodyUpdateSalary)

      if(resultUpdateStatus.data === 'Salary status updated Successfully'){
        yield put(updateAdminSalaryStatusSuccess(result.data))
      }
    } else {
      yield put(updateAdminBankPaymentFailed(result.data))
    }
    yield put(searchAdminWages())
  } catch (e) {
    console.warn(e)
  }
} */

function* adminAddNewUpdatesSaga({ formValues }) {
  try {
    const url = `${API_SERVER}/AddNewUpdates`
    const body = JSON.stringify({
      newsupdate: formValues.company_update
    })
    const result = yield call(apiManualPost, url, body)

    if (result.data === 'company update added successfully') {
      yield put(adminGetUpdates())
      yield put(getUserCompanyUpdateInfo())
    } else {
      console.warn(result.data)
    }
  } catch (e) {
    console.warn(e)
  }
}

function* adminDeleteCompanyUpdatesSaga({ id }) {
  try {
    const url = `${API_SERVER}/DeleteCompanyUpdate`
    const body = JSON.stringify({
      id: id
    })
    const result = yield call(apiManualPost, url, body)
    //console.log('Inside adminDeleteCompanyUpdatesSaga:: ', result)

    if (result.data === 'company update deleted successfully') {
      yield put(adminGetUpdates())
    } else {
      console.warn(result.data)
    }
  } catch (e) {
    console.warn(e)
  }
}

function* adminGetUpdatesSaga() {
  try {
    const url = `${API_SERVER}/GetCompanyUpdates`
    const result = yield call(apiManualRequest, url)
    const resultParsed = JSON.parse(result.data)
    //console.log('Inside adminGetUpdatesSaga:: ', resultParsed)
    yield put(adminGetUpdatesSuccess(resultParsed))
  } catch (e) {
    console.warn(e)
  }
}

function* showSalaryPDFSaga({ salary_id, uuid, invoice_uuid }) {
  try {
    const url = `${API_SERVER}/GenerateSalaryPDF`

    const body = JSON.stringify({
      id: salary_id,
      uuid: uuid,
      invoice_uuid: invoice_uuid
    })
    yield call(apiBlobPost, url, body)
  } catch (e) {
    console.warn(e)
  }
}

function* showInvoicePDFSaga({ invoice_id }) {
  try {
    const url = `${API_SERVER}/InvoiceDownloadPDF`
    const id = invoice_id.split('$$')
    const uuid = id[0]
    const inv_id = id[1]
    const body = JSON.stringify({
      invoice_id: inv_id,
      uuid: uuid,
      remindersent: 0
    })
    yield call(apiBlobPost, url, body)
  } catch (e) {
    console.warn(e)
  }
}

function* showReminderInvoicePDFSaga({ invoice_id }) {
  try {
    const url = `${API_SERVER}/InvoiceDownloadPDF`
    const id = invoice_id.split('$$')
    const uuid = id[0]
    const inv_id = id[1]
    const body = JSON.stringify({
      invoice_id: inv_id,
      uuid: uuid,
      remindersent: 1
    })
    yield call(apiBlobPost, url, body)
  } catch (e) {
    console.warn(e)
  }
}

function* sentInvoiceReminderSaga({ invoice_id }) {
  try {
    const url = `${API_SERVER}/GenerateInvoiceReminderPDF`
    const id = invoice_id.split('$$')
    const uuid = id[0]
    const inv_id = id[1]
    const body = JSON.stringify({
      invoice_id: inv_id,
      uuid: uuid
    })
    yield call(apiManualPost, url, body)
    yield put(updateAdminTable())
  } catch (e) {
    console.warn(e)
  }
}

function* getAdminExpenseReportSaga({ formValues }) {
  try {
    let startdate
    if (formValues.start_date !== undefined) {
      startdate = formatFiToISO(
        new DateTimeFormat('fi', {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric'
        })
          .format(new Date(formValues.start_date))
          .split('.')
      )
    }

    let enddate
    if (formValues.end_date !== undefined) {
      enddate = formatFiToISO(
        new DateTimeFormat('fi', {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric'
        })
          .format(new Date(formValues.end_date))
          .split('.')
      )
    }

    const expImageUrl = `${API_SERVER}/GetExpenseReportMonthly`
    const expPDFUrl = `${API_SERVER}/ExpensesPDF`

    const body = JSON.stringify({
      startDate: startdate,
      EndDate: enddate
    })

    const expImageResult = yield call(apiManualPost, expImageUrl, body)

    const expPDFResult = yield call(apiManualPost, expPDFUrl, body)

    if (
      expImageResult.data.status === true &&
      expPDFResult.data.status === true
    ) {
      yield put(getAdminExpenseReportSuccess())
    } else if (
      expImageResult.data.status === false &&
      expPDFResult.data.status === false
    ) {
      yield put(
        getAdminExpenseReportFailed(
          'Kuluraportteja ei luoda, valitse päivämäärät uudelleen!'
        )
      )
    } else if (
      expImageResult.data.status === false ||
      expPDFResult.data.status === false
    ) {
      yield put(
        getAdminExpenseReportFailed(
          'Yhtä kuluraportista ei syntynyt, valitse päivämäärät uudelleen!'
        )
      )
    }
  } catch (e) {
    console.warn(e)
  }
}

function* cancelUpdateAdminSalaryStatusSaga() {
  yield delay(100)
  yield put(cancelUpdateAdminSalaryStatusSuccess())
}

function* searchCompanyCustomersSaga({ email }) {
  try {
    yield put(
      setFieldValue('adminSearchCustomer', [{ field: 'email', value: email }])
    )
    yield put(searchAdminUsers({ email: email }))
  } catch (e) {
    console.warn(e)
  }
}

function* searchCompanyInvoicesSaga({ email }) {
  try {
    yield put(
      setFieldValue('adminSearchInvoice', [
        { field: 'user_email', value: email },
        { field: 'yearSelect', value: '' }
      ])
    )

    yield put(
      searchAdminInvoice(null, true, {
        adminInvoicePageSize: 20,
        user_email: email
      })
    )
  } catch (e) {
    console.warn(e)
  }
}

function* searchCompanySalariesSaga({ email }) {
  try {
    yield put(
      setFieldValue('adminSearchCustomer', [
        { field: 'email', value: email },
        { field: 'yearSelect', value: '' }
      ])
    )

    yield put(
      searchAdminWages(null, true, {
        adminSalaryPageSize: 20,
        email: email
      })
    )
  } catch (e) {
    console.warn(e)
  }
}

function* adminSalaryExpandSaga({ expanded, id, index }) {
  try {
    if (!expanded) {
      yield put(expandAdminSalaryFalse(id))
    } else {
      const salaryResult = store.getState().admin.salarySearchRows[index]
      if (salaryResult) {
        yield put(expandAdminSalaryTrue(salaryResult))
      }
    }
  } catch (e) {
    console.warn(e)
  }
}

function* adminSalaryUpdateSaga({ formValues }) {
  try {
    const adminSalaryEdit = store.getState().admin.adminSalaryEdit
    const updateSalaryUrl = `${API_SERVER}/UpdateSalary`

    const body = JSON.parse(
      JSON.stringify({
        id: adminSalaryEdit.id,
        uuid: adminSalaryEdit.uuid,
        ulosotto: parseFloat(formValues.ulosotto_sum_govpay_update),
        manual_ulosotto: parseFloat(formValues.manual_sum_govpay_update),
        notes: formValues.notes,
        take_home_pay: parseFloat(formValues.take_home_pay_update),
        salarytype: formValues.salarytype
      })
    )

    yield call(apiManualPost, updateSalaryUrl, JSON.stringify(body))
    yield put(closeAdminSalaryFormsSuccess())
    yield put(updateAdminTable())
  } catch (e) {
    console.warn(e)
  }
}

function* downloadCustomersReportSaga({ values }) {
  try {
    yield call(createExcelCustomersReport, values)
  } catch (e) {
    console.warn(e)
  }
}

function* getAdminSalaryUlosottoInfo({ uuid }) {
  try {
    const url = `${API_SERVER}/GetUserMonthlyPaidUlosottoAmount`
    const body = JSON.stringify({ uuid })

    const result = yield call(apiManualPost, url, body)

    if (result.data) {
      const parsedData = JSON.parse(result.data)[0]
      yield put(getAdminSalaryUlosottoInfoSuccess(parsedData))
    }
  } catch (e) {
    console.warn(e)
  }
}

export function* watchAdminUsersSearchSaga() {
  yield takeEvery(SEARCH_ADMIN_USERS, adminUsersSearchSaga)
}

export function* watchAdminInvoiceSearchSaga() {
  yield takeEvery(SEARCH_ADMIN_INVOICE, adminInvoiceSearchSaga)
}

export function* watchAdminInvoiceExpandSaga() {
  yield takeEvery(EXPAND_ADMIN_INVOICE, adminInvoiceExpandSaga)
}

export function* watchAdminInvoiceUpdateSaga() {
  yield takeEvery(UPDATE_ADMIN_INVOICE, adminInvoiceUpdateSaga)
}

export function* watchAdminUserExpandSaga() {
  yield takeEvery(EXPAND_ADMIN_USER, adminUserExpandSaga)
}

export function* watchAdminUserUpdateSaga() {
  yield takeEvery(UPDATE_ADMIN_USER, adminUserUpdateSaga)
}

export function* watchAdminWagesSearchSaga() {
  yield takeEvery(SEARCH_ADMIN_WAGES, adminWagesSearchSaga)
}

export function* watchAdminUpdateInvoiceStatusSaga() {
  yield takeEvery(UPDATE_ADMIN_INVOICE_STATUS, adminUpdateInvoiceStatusSaga)
}

export function* watchAdminUpdateInvoiceStatustoRejectedSaga() {
  yield takeEvery(
    UPDATE_ADMIN_INVOICE_STATUS_REJECTED,
    adminUpdateInvoiceStatustoRejectedSaga
  )
}

export function* watchAdminUpdateInvoiceStatustoNewSaga() {
  yield takeEvery(
    UPDATE_ADMIN_INVOICE_STATUS_NEW,
    adminUpdateInvoiceStatustoNewSaga
  )
}

export function* watchAdminUpdateInvoiceStatustoKeskeytettySaga() {
  yield takeEvery(
    UPDATE_ADMIN_INVOICE_STATUS_KESKEYTETTY,
    adminUpdateInvoiceStatustoKeskeytettySaga
  )
}

export function* watchAdminUpdateInvoiceStatustoLoanedSaga() {
  yield takeEvery(
    UPDATE_ADMIN_INVOICE_STATUS_LOANED,
    adminUpdateInvoiceStatustoLoanedSaga
  )
}

export function* watchAdminUpdateInvoiceStatustoNotAcceptedSaga() {
  yield takeEvery(
    UPDATE_ADMIN_INVOICE_STATUS_NOT_ACCEPTED,
    adminUpdateInvoiceStatustoNotAcceptedSaga
  )
}

export function* watchAdminUpdateInvoiceStatustoPaidAndNewInvoiceSaga() {
  yield takeEvery(
    UPDATE_ADMIN_INVOICE_STATUS_PAID_AND_NEW_INVOICE,
    adminUpdateInvoiceStatustoPaidAndNewInvoiceSaga
  )
}

export function* watchAdminUpdateInvoiceStatustoPerinnassaSaga() {
  yield takeEvery(
    UPDATE_ADMIN_INVOICE_STATUS_PERINNASSA,
    adminUpdateInvoiceStatustoPerinnassaSaga
  )
}

export function* watchAdminNoPikapalkkaSaga() {
  yield takeEvery(NO_PIKAPALKKA, noPikapalkkaSaga)
}

export function* watchAdminUpdateSalaryStatusSaga() {
  yield takeEvery(UPDATE_ADMIN_SALARY_STATUS, adminUpdateSalaryStatusSaga)
}

export function* watchAdminAddNewUpdatesSaga() {
  yield takeEvery(ADMIN_ADD_NEW_UPDATES, adminAddNewUpdatesSaga)
}

export function* watchAdminDeleteCompanyUpdateSaga() {
  yield takeEvery(ADMIN_DELETE_COMPANY_UPDATE, adminDeleteCompanyUpdatesSaga)
}

export function* watchAdminGetUpdatesSaga() {
  yield takeEvery(ADMIN_GET_UPDATES, adminGetUpdatesSaga)
}

export function* watchShowSalaryPDFSaga() {
  yield takeEvery(SHOW_SALARY_PDF, showSalaryPDFSaga)
}

export function* watchShowInvoicePDFSaga() {
  yield takeEvery(SHOW_INVOICE_PDF, showInvoicePDFSaga)
}

export function* watchsentInvoiceReminderSaga() {
  yield takeEvery(SENT_INVOICE_REMINDER, sentInvoiceReminderSaga)
}

export function* watchImportKassavirtanenSalariesSaga() {
  yield takeEvery(
    IMPORT_KASSAVIRTANEN_SALARIES,
    importKassavirtanenSalariesSaga
  )
}

export function* watchSalarySendToIRSaga() {
  yield takeEvery(SALARY_SEND_TO_IR, salarySendToIRSaga)
}
export function* watchcancelSalaryIRReportSaga() {
  yield takeEvery(CANCEL_SALARY_IR_REPORT, cancelSalaryIRReportSaga)
}
export function* watchadminsearchIRSalaryInfoSaga() {
  yield takeEvery(SEARCH_ADMIN_IR, adminsearchIRSalaryInfoSaga)
}

export function* watchupdateSalaryStatusIRSaga() {
  yield takeEvery(UPDATE_ADMIN_SALARY_STATUS_IR, updateSalaryStatusIRSaga)
}

export function* watchManualPaySalariesSaga() {
  yield takeEvery(MANUAL_PAY_SALARIES, manualPaySalariesSaga)
}

export function* watchShowReminderInvoicePDFSaga() {
  yield takeEvery(SHOW_REMINDER_INVOICE_PDF, showReminderInvoicePDFSaga)
}

export function* watchGetAdminExpenseReportSaga() {
  yield takeEvery(GET_ADMIN_EXPENSE_REPORT, getAdminExpenseReportSaga)
}

export function* watchCancelUpdateAdminSalaryStatus() {
  yield takeEvery(
    CANCEL_UPDATE_ADMIN_SALARY_STATUS,
    cancelUpdateAdminSalaryStatusSaga
  )
}

export function* watchSearchCompanyCustomersSaga() {
  yield takeEvery(SEARCH_COMPANY_CUSTOMERS, searchCompanyCustomersSaga)
}

export function* watchSearchCompanyInvoicesSaga() {
  yield takeEvery(SEARCH_COMPANY_INVOICES, searchCompanyInvoicesSaga)
}

export function* watchSearchCompanySalariesSaga() {
  yield takeEvery(SEARCH_COMPANY_SALARIES, searchCompanySalariesSaga)
}

export function* watchShowLatestInvoicePDFSaga() {
  yield takeEvery(SHOW_LATEST_INVOICE_PDF, showLatestInvoicePDFSaga)
}

export function* watchAdminSalaryExpandSaga() {
  yield takeEvery(EXPAND_ADMIN_SALARY, adminSalaryExpandSaga)
}

export function* watchAdminSalaryUpdateSaga() {
  yield takeEvery(UPDATE_ADMIN_SALARY, adminSalaryUpdateSaga)
}

export function* watchGetAdminSalaryUlosottoInfo() {
  yield takeEvery(GET_ADMIN_SALARY_ULOSOTTO_INFO, getAdminSalaryUlosottoInfo)
}

export function* watchDownloadCustomersReportSaga() {
  yield takeEvery(DOWNLOAD_CUSTOMERS_REPORT, downloadCustomersReportSaga)
}
